module.exports = __webpack_public_path__ + "img/back_m_active4.8bed3d4e.png";